import type { SVGAttributes } from 'react';

export function ShareFacebookIcon(props: SVGAttributes<SVGSVGElement>) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" {...props} viewBox="0 0 24 24">
			<rect width="24" height="24" fill="#fff" rx="4" />
			<path
				fill="currentColor"
				d="M12.976 18v-5.474h1.93l.289-2.133h-2.219V9.031c0-.618.18-1.038 1.11-1.038l1.187-.001V6.084A17 17 0 0 0 13.544 6c-1.71 0-2.882.994-2.882 2.82v1.573H8.728v2.133h1.934V18z"
			/>
		</svg>
	);
}
